import { RouteObject } from '@suntex.core/nav'
import { EntityLevel } from '@suntex.fim/enums'

import Rankings from '../pages/app/Ranking/Rankings'
import TopPlayersAndTeams from '../pages/app/Ranking/TopPlayersAndTeams'
import WallOfFameTool from '../pages/app/Ranking/WallOfFameTool'

const defaultRankingRoutes: RouteObject[] = [
  {
    path: 'rankings/*',
    Component: Rankings
  }
]

const teamRankingRoutes: RouteObject[] = [
  {
    path: 'rankings/wall-of-fame-tool',
    element: <WallOfFameTool />
  },
  {
    path: 'rankings/*',
    Component: Rankings
  }
]
const schoolRankingRoutes: RouteObject[] = [
  {
    path: 'rankings/wall-of-fame-tool',
    element: <WallOfFameTool />
  },
  {
    path: 'rankings/top-players-teams',
    element: <TopPlayersAndTeams />
  },
  {
    path: 'rankings/*',
    Component: Rankings
  }
]

/**
 * Get all ranking routes for a specific context
 */
export function getRankingRoutes(context: EntityLevel): RouteObject[] {
  switch (context) {
    case EntityLevel.Team:
      return teamRankingRoutes
    case EntityLevel.School:
      return schoolRankingRoutes
    default:
      return defaultRankingRoutes
  }
}
